import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  resolveRecommendation,
  wizardQuestions,
  type WizardOption,
} from "../content/wizard";
import { caseStudies } from "../content/cases";

function Wizard() {
  const [step, setStep] = useState(0);
  const [selections, setSelections] = useState<WizardOption[]>([]);

  const totalSteps = wizardQuestions.length;
  const isDone = step >= totalSteps;

  const choose = (option: WizardOption) => {
    setSelections((prev) => {
      const next = [...prev];
      next[step] = option;
      return next;
    });
    setStep((s) => s + 1);
  };

  const goBack = () => setStep((s) => Math.max(0, s - 1));
  const restart = () => {
    setSelections([]);
    setStep(0);
  };

  if (isDone) {
    const recommendation = resolveRecommendation(selections);
    const related = caseStudies.filter((c) =>
      recommendation.relatedCases.includes(c.slug),
    );

    return (
      <div className="wizard wizard-result">
        <p className="kicker">We recognise this</p>
        <h2 className="wizard-headline">{recommendation.headline}</h2>
        <p className="wizard-body">{recommendation.body}</p>

        {related.length ? (
          <div className="wizard-related">
            <span className="wizard-related-title">Where we've done it</span>
            <ul>
              {related.map((c) => (
                <li key={c.slug}>
                  <Link to={`/work#${c.slug}`}>{c.client}</Link> — {c.summary}
                </li>
              ))}
            </ul>
          </div>
        ) : null}

        <div className="wizard-actions">
          <Link className="cta-button" to={recommendation.cta.to}>
            {recommendation.cta.label}
          </Link>
          <button type="button" className="link-button" onClick={restart}>
            Start over
          </button>
        </div>
      </div>
    );
  }

  const question = wizardQuestions[step];

  return (
    <div className="wizard">
      <div className="wizard-progress" aria-hidden="true">
        {wizardQuestions.map((q, i) => (
          <span
            key={q.id}
            className={`wizard-dot ${i <= step ? "is-filled" : ""}`}
          />
        ))}
      </div>
      <p className="wizard-step-label">
        Question {step + 1} of {totalSteps}
      </p>
      <h2 className="wizard-question">{question.question}</h2>

      <div className="wizard-options">
        {question.options.map((option) => (
          <button
            key={option.label}
            type="button"
            className={`wizard-option ${
              selections[step]?.label === option.label ? "is-selected" : ""
            }`}
            onClick={() => choose(option)}
          >
            {option.label}
          </button>
        ))}
      </div>

      {step > 0 ? (
        <button type="button" className="link-button" onClick={goBack}>
          Back
        </button>
      ) : null}
    </div>
  );
}

export default Wizard;
